import axios from 'axios'
const { VUE_APP_API_URL, VUE_APP_TEST_ERROR } = process.env

const checkFeedbackExists = async (bookingNumber, fil) => {
  let result = { error: false }
  try {
    const url = VUE_APP_TEST_ERROR || `${VUE_APP_API_URL}/api/feedback/${bookingNumber}/${fil}`

    const res = await axios.get(url)
    if (res && res.data) {
      result = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

const getConsImage = async (image) => {
  let result = { error: false }
  try {
    const res = await axios
      .get(`${VUE_APP_API_URL}${image}`)
    if (res && res.data) {
      result = res.config
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

export {
  checkFeedbackExists,
  getConsImage
}
